import { AutogenModelRoutingGuideUsers, AutogenRowRoutingGuideUsers } from "./autogen/AutogenModelRoutingGuideUsers";

export class ModelRoutingGuideUsers extends AutogenModelRoutingGuideUsers<RowRoutingGuideUsers> {
    constructor() {
        super(RowRoutingGuideUsers);
    }
}

export class RowRoutingGuideUsers extends AutogenRowRoutingGuideUsers {
}